module.exports = __webpack_public_path__ + "img/37619-001.2eba9ef7.jpg";